'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleInputStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {};
var defaultProps = {};
/** STYLES */

var ToggleInputStyled = exports.ToggleInputStyled = _styledComponents2.default.input.withConfig({
  displayName: 'ToggleInputStyled'
})(['', ';', ';'],
/* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */
'', _reactackleCore.elementInvisible);

ToggleInputStyled.propTypes = propTypes;
ToggleInputStyled.defaultProps = defaultProps;
ToggleInputStyled.displayName = 'ToggleInputStyled';